<!-- 合并明细 -->
<template>
    <div v-loading="loading">
        <div class="search-ctn" style="margin-bottom: 10px">
            <div class="search-ctn-left">
                <el-button size="small" class="search-btn btn-primary" v-if="permission.disassAccount"
                    @click="disassAccount">{{ permission.disassAccount }}</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border="" style="width: 100%; margin-bottom: 0px">
                <el-table-column show-overflow-tooltip width="210px" prop="OrderCode" label="单号">
                    <template slot-scope="scope">
                        <div style="display: flex; flex-direction: row">
                            <i v-if="scope.row.OrderId"><el-link :underline="false" :href="scope.row.OrderType == 0
                                    ? '/#/purchaseManage/purchaseOrders/check?id=' + scope.row.OrderId
                                    : '/#/purchaseManage/purchasesReturns/edit_v2?type=1&PReturnId=' + scope.row.OrderId
                                " target="_blank">{{ scope.row.OrderCode }}</el-link></i>
                            <i v-else>{{ scope.row.OrderCode }}</i>
                            <img v-show="scope.row.OrderId" src="@/assets/images/preview.png" title="打印预览" style="margin-left: 5px; width: 24px; height: 24px"
                                @click.stop="viewOrderDetail(scope.row.OrderType, scope.row.OrderId, scope.row.OrderCode)" />
                        </div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="OrderType" label="单据类型">
                    <template slot-scope="scope">
                        <i v-if="scope.row.OrderType == 0" class="c-active">采购付款</i>
                        <i v-else-if="scope.row.OrderType == 1" class="out-active">采购退货</i>
                        <i v-else>建账</i>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="PayTypeName" label="支付方式"></el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="TotalAmount" label="应付总额">
                    <template slot-scope="scope">{{ scope.row.OrderType != 1 ? scope.row.TotalAmount : -scope.row.TotalAmount }}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip min-width="100px" prop="Remark" label="备注"></el-table-column>
                <el-table-column show-overflow-tooltip width="75px" prop="SName" label="开单人"></el-table-column>
            </el-table>
        </div>
        <el-dialog :close-on-click-modal="false" :append-to-body="true" title="打印" :before-close="closeOrderPrintDialog" :visible.sync="printOrderPreview" width="870px">
            <div class="dialog-content" v-if="printOrderPreview">
                <printContent @closeDialog="closeOrderPrintDialog" :printIds="idList" :canPrint="true" :isInit="true"></printContent>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :append-to-body="true" title="打印" :before-close="closeOrderPrintDialog" :visible.sync="printReturnPreview" width="870px">
            <div class="dialog-content" v-if="printReturnPreview">
                <printReturnContent @closeDialog="closeOrderPrintDialog" :printIds="idList" :isInit="true"></printReturnContent>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import printSupPayable from '@/components/printModels/printSupPayable';
import printSupPayableList from '@/components/printModels/printSupPayableList';
export default {
    name: '',
    props: ['RecordId'],
    components: {
        printSupPayable,
        printSupPayableList
    },
    data() {
        return {
            loading: false,
            tableData: [],
            permission: {},
            printOrderPreview: false,
            printReturnPreview: false,
            idList:[]
        };
    },
    mounted() {
        this.permission = this.$util.getPermission('SupPayable_H');
        this.getDetails();
    },
    methods: {
        cancel() {
            this.$emit('closeDetails');
        },
        getDetails() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/RevenueManagement_H/GetSupCombineDetail',
                    hideLoading: true,
                    data: { RecordId: this.RecordId }
                })
                .then(res => {
                    if (!res.data) return;
                    this.tableData = res.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        disassAccount() {
            let recordId = this.RecordId;
            let that = this;
            this.$util.elConfirm({
                content: '您是否要拆解该条合并帐？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: `/api/RevenueManagement_H/DisassAccounts?recordId=${recordId}`,
                            hideLoading: true
                        })
                        .then(res => {
                            that.$util.successMsg('拆解成功');
                            that.$emit('closeDetails', true);
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            });
        },
        closeOrderPrintDialog() {
            this.printOrderPreview = false;
            this.printReturnPreview = false;
            this.idList = [];
        },
        viewOrderDetail(orderType, orderId, orderCode) {
            if (orderId) {
                if (orderType == 0) {
                    this.idList.push({
                        id: orderId,
                        orderCode: orderCode
                    });
                    this.printOrderPreview = true;
                } else if (orderType == 1) {
                    this.idList.push({
                        PReturnId: orderId
                    });
                    this.printReturnPreview = true;
                }
            } else {
                this.$util.warningMsg('要打印的订单异常，请刷新后重新操作');
            }
        }
    }
};
</script>
<style lang="less" scoped>
.dialog-content {
    margin: 5px;
}

.btn-ctn {
    text-align: right;
}

.el-row {
    margin-bottom: 0px;

    &:last-child {
        margin-bottom: 0;
    }
}
</style>
